import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Gamepad2 } from 'lucide-react'
import useAudioManager from '../hooks/useAudioManager'
import { getGameModeNavigationItems } from '../config/navigationConfig'

const Games = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { playSound } = useAudioManager({
    select: 'select'
  })

  // Прокручиваем страницу наверх при монтировании компонента
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }, [])

  const gamesModes = getGameModeNavigationItems(t)

  return (
    <div className="min-h-screen bg-dark-primary text-white p-4">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-accent-primary mb-2 flex items-center gap-3 justify-center">
          <Gamepad2 size={32} />
          {t('games.title')}
        </h1>
      </div>

      {/* Game Modes Grid - 2 колонки, Market на всю ширину */}
      <div>
        <div className="grid grid-cols-2 gap-3">
          {gamesModes.map((mode, index) => {
            // Только маркет на всю ширину
            const isFullWidth = mode.id === 'market'
            const Icon = mode.icon
            const isDisabled = !mode.available
            
            return (
              <button
                key={mode.id}
                onClick={() => {
                  if (mode.available) {
                    playSound('select')
                    navigate(mode.path)
                  }
                }}
                disabled={isDisabled}
                className={`
                  relative overflow-hidden
                  ${isFullWidth ? 'col-span-2' : ''}
                  ${isDisabled ? 'bg-surface/50 border border-white/10 cursor-not-allowed opacity-60' : `bg-gradient-to-br ${mode.bgGradient} border ${mode.borderColor}`}
                  ${isFullWidth ? 'p-4' : 'p-6'} rounded-xl
                  transform transition-all duration-300
                  ${!isDisabled && `hover:scale-[1.02] active:scale-[0.98] hover:shadow-lg ${mode.shadowColor}`}
                  animate-fade-in
                `}
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                {/* Светящийся оверлей */}
                {!isDisabled && (
                  <div className={`absolute inset-0 bg-gradient-to-br ${mode.overlayGradient} to-transparent`} />
                )}

                {/* Контент карточки */}
                <div className={`relative z-10 flex ${isFullWidth ? 'flex-row items-center gap-4' : 'flex-col items-center gap-3'}`}>
                  {/* Иконка */}
                  <div className={`${isFullWidth ? 'w-12 h-12' : 'w-16 h-16'} rounded-full ${isDisabled ? 'bg-white/5 border-white/10' : `${mode.iconBg} ${mode.iconBorder}`} border-2 flex items-center justify-center shadow-lg ${!isDisabled ? mode.shadowColor : ''} flex-shrink-0`}>
                    <Icon size={isFullWidth ? 24 : 32} className={isDisabled ? 'text-gray-500' : mode.textColor} />
                  </div>
                  
                  {/* Заголовок и бейджи */}
                  <div className={`flex ${isFullWidth ? 'flex-row items-center gap-3 flex-1' : 'flex-col items-center gap-3'}`}>
                    <h2 className={`text-base font-bold ${isDisabled ? 'text-gray-500' : 'text-white'}`}>
                      {mode.title}
                    </h2>

                    {/* Бейдж "Скоро" */}
                    {isDisabled && (
                      <div className="px-3 py-1 bg-gray-500/20 border border-gray-500/30 rounded-full">
                        <span className="text-xs font-semibold text-gray-400">
                          {t('games.comingSoon')}
                        </span>
                      </div>
                    )}
                    
                    {/* Бейдж "Новое" для новых режимов */}
                    {!isDisabled && mode.isNew && (
                      <div className={`px-3 py-1 ${mode.badgeBg} border ${mode.badgeBorder} rounded-full`}>
                        <span className={`text-xs font-semibold ${mode.textColor}`}>
                          {t('games.new')}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default Games
